import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";

import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import { Icon } from "leaflet";

const icon = new Icon({
    iconUrl: require('./../../../assets/images/NoPath.png'),
    iconSize: [0, 0],
    iconAnchor: [40, 90],
    popupAnchor: [-25, -40],
});

// Cordinates of Marcillac

function LeafletgeoSearch() {
  const map = useMap();
  useEffect(() => {
    const provider = new OpenStreetMapProvider();

    const searchControl = new GeoSearchControl({
      provider,
      marker: {
        icon
      }
    });

    map.addControl(searchControl);

    return () => map.removeControl(searchControl);
  }, []);

  return null;
}

class MapWrapper extends React.Component {
  render() {
    return (
          <LeafletgeoSearch />
    );
  }
}

export default MapWrapper;
